/*
 *   File : phone-input.js
 *   Author : https://evoqins.com
 *   Description : Input element
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo, useEffect, useState } from "react";
import PhoneInput from 'react-phone-number-input';
import { getCountryCallingCode } from 'react-phone-number-input/input';
// import { parsePhoneNumber } from 'react-phone-number-input';

// Components
import { PhoneCountrySelectModal } from "../Modal";
import { event } from "jquery";

const CustomPhoneInput = (props) => {

    const [inputValue, setInputValue] = useState("");
    const [isInputFocused, setIsInputFocused] = useState(false);

    useEffect(() => {
        setInputValue(props.value || ""); //already entered number
    }, [props.value]);

    useEffect(() => {

        window.addEventListener("click", (event) => {
            // console.log(event.target);
            if (!event.target.closest(".custom-phone-otp") && !inputValue) {
                setIsInputFocused(false);
            }
        })
    }, [inputValue]);


    //input handle change
    function _handleChange(value) {
        setInputValue(value);
        props.handleChange(value);
    };

    // handle country select
    function _handleCountrySelect(country) {

        if (country) {
            let country_code = "+" + getCountryCallingCode(country);
            props.handleChange(inputValue, country_code, country);
        }

    };

    // handle focus input
    const _handleFocusInput = () => {
        clearTimeout(window.phoneBlurTimeout);
        setIsInputFocused(true);
    };

    const _handleFocusPhoneInput = () => {
        clearTimeout(window.phoneBlurTimeout);
        document.querySelector(`#${props.id}-custom-phone-otp-input`).focus();
    };

    // const blur input
    const _handleBlurInput = (event) => {
        event.preventDefault();
        // setTimeout(() => {
        //     if (document.querySelector(("#phone-country-modal")) === null) {
        //         setIsInputFocused(false);
        //     }
        // }, 200);
    };



    return (
        <div id={props.id} className={"custom-phone-otp"}>

            <div className={` ${props.error ? "error" : ""} ${isInputFocused ? "phoneInputFocused " : ""} position-relative`} onClick={_handleFocusInput}>
                {
                    props.floatingLabel &&
                    <label className={`${props.labelClass}  e-font-weight-400 floating-label-phone e-text-charleston-green  e-alt-font-poppins line-height-24px e-font-14`}>
                        {props.label}
                        {
                            props.require &&
                            <span className='e-text-sunset-orange'>*</span>
                        }
                    </label>
                }

                {
                    props.label && props.floatingLabel === false &&
                    <label className={`${props.labelClass} e-text-charleston-green e-font-weight-400 e-alt-font-poppins line-height-24px e-font-14 pb-2`}>
                        {props.label}
                        {
                            props.require &&
                            <span className='e-text-sunset-orange'>*</span>
                        }
                    </label>
                }

                <PhoneInput
                    className={props.containerClassName}
                    defaultCountry={props.selectedCountryLocale || "IN"}
                    value={inputValue}
                    limitMaxLength
                    onChange={_handleChange}
                    disabled={props.disabled}
                    inputComponent={CustomInput}
                    numberInputProps={{ id: props.id, country_code: props.selectedCountryCode, disabled: props.disabled, isInputFocused: isInputFocused, floatingLabel: props.floatingLabel, handleBlur: _handleBlurInput, handleFocus: _handleFocusInput }}
                    onCountryChange={_handleCountrySelect}
                    countrySelectComponent={({ value, onChange }) => (
                        <PhoneCountrySelectModal value={value}
                            inputValue={inputValue}
                            selectedCountryCode={props.selectedCountryCode}
                            type={props.noScrollId}
                            phoneInputWrapper={props.id}
                            disableCountrySelect={props.disableCountrySelect}
                            handleCountrySelect={onChange}
                            handleCloseModal={_handleFocusPhoneInput} />
                    )}
                />
                {
                    props.textLink &&
                    <p className={`cursor-pointer e-text-egyptian-blue me-3 mb-0 position-absolute end-0 top-50 translate-middle-y e-font-14 e-font-weight-500 e-alt-font-poppins line-height-24px`}
                        onClick={props.handleSendOtp}>
                        {props.textLabel}
                    </p>
                }

                <p className={`e-error-message e-font-12 e-font-weight-400 e-primary-font-inter-font line-height-30 e-text-red mb-0 position-absolute top-100 start-0 padding-2-top`}>
                    {props.error}
                </p>

            </div>


        </div >
    )
}

export default memo(CustomPhoneInput);

CustomPhoneInput.defaultProps = {
    floatingLabel: false
}


const CustomInput = React.forwardRef(({ id, value, onChange, country_code, disabled, isInputFocused, floatingLabel, handleBlur, handleFocus }, ref) => {

    // Removing country code
    let input_value = value;
    if (country_code === "+91") {
        input_value = input_value.replace(/^\+91\s?/, '').replace(/\s+/g, '');
    } else {
        input_value = input_value.replace(country_code, '').replace(/\s+/g, '').replace(/\D/g, '');
    }

    const _handleChange = (event) => {
        let value = event.target.value;
        if (country_code === "+91") {
            if (value.length < 11) {
                onChange(value);
            }
        } else {
            if (value.length < 11) {
                onChange(value);
            }
        }
    };

    useEffect(() => {
        if (isInputFocused) {
            document.querySelector(`#${id}-custom-phone-otp-input`)?.focus();
        }
    }, [isInputFocused]);

    return (
        <input id={`${id}-custom-phone-otp-input`}
            disabled={disabled}
            ref={ref}
            placeholder={isInputFocused || floatingLabel === false ? "98765 43210" : ""}
            value={input_value}
            onChange={_handleChange}
            onBlurCapture={handleBlur}
            onFocus={handleFocus}
            className={`${floatingLabel === false ? "no-floating" : ""} w-100 border-0 no-outline`}
        />
    )
})
